<template>
    <div>
<!--        已作废-->
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage" @search-change="searchChange" @search-reset="resetChange">
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="system_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.system_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.system_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="faqi_ren" slot-scope="scope" >
                <el-tooltip :content="scope.row.faqi_ren" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.faqi_ren }}</p>
                </el-tooltip>
            </template>
            <template slot="all_signers" slot-scope="scope" >
                <el-tooltip :content="scope.row.all_signers" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.all_signers }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { allContracts, allContractsSearch } from '../../../api/allContracts';

    export default {
        name: 'invalidatePage',
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [],
                doc_title:'',
                all_signers:'',
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menu:false,
                    column:[
                        {
                            label:'合同名称',
                            prop:'doc_title',
                            search:true
                        }, {
                            label:'平台编号',
                            prop:'system_sn'
                        },
                        // {
                        //     label:'合同编号',
                        //     prop:'contract_sn'
                        // },
                        {
                            label:'发起人',
                            prop:'faqi_ren'
                        },  {
                            label:'发起时间',
                            prop:'faqi_time'
                        },  {
                            label:'参与人',
                            prop:'all_signers',
                            width:'500',
                            search: true
                        },  {
                            label:'合同状态',
                            prop:'ct_status_txt'
                        },  {
                            label:'合同完成时间',
                            prop:'finish_time'
                        }
                    ]
                },
            };
        },
        methods:{
            //分页
            changePage(num){
                if (this.doc_title==''&&this.all_signers=='') {
                    allContracts(6, 10, num).then(res => {
                        this.data = res.data.list
                        this.page.total = res.data.count
                    })
                }else {
                    //搜索后分页
                    allContractsSearch(6,10,num,this.doc_title,this.all_signers).then(res=>{
                        if (res.code==200){
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }
            },
            //搜索
            searchChange(from,done){
                allContractsSearch(6,10,1,from.doc_title,from.all_signers).then(res=>{
                    this.doc_title=from.doc_title
                    this.all_signers=from.all_signers
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
                done()
            },
            //重置搜索
            resetChange(){
                this.doc_title=''
                this.all_signers=''
                allContracts(6,10,1).then(res=>{
                    this.data=res.data.list
                    this.page.total=res.data.count
                    this.page.currentPage=1
                })
            }
        },
        created() {
            this.resetChange()
        }
    };
</script>

<style scoped>
    /deep/.el-col{
        width: 25%;
    }
    /deep/.avue-form__menu{
        padding: 0px;
    }
    /deep/ .el-tabs__active-bar{
        background-color: #3d62f6;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
    ::v-deep .avue-crud__menu{
        min-height:0px !important;
        height: 0px !important;
    }
</style>
